import * as React from "react";
import "./Testimonials.scss";
import CarouselLayout from "./Layouts/Carousel";
import GridLayout from "./Layouts/Grid";
import ScrollingLayout from "./Layouts/Scrolling";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import useInViewComponent from "@arctheme-hooks/useInViewComponent";
import {useEffect, useState} from "react";
import { Image } from "@arctheme-components/elements/Image/Image";

const layouts = {
  carousel: CarouselLayout,
  grid: GridLayout,
  scrolling: ScrollingLayout,
};

export const Testimonials = ({ settings }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  let Layout = layouts[settings.section.layout] || CarouselLayout;

  const { blocks } = settings;
  let sortedBlocks = blocks;

  let backgroundImage = settings.section.background_image;

  if (blocks) {
    if (isMobile) {
      // Sort blocks based on the sort_order setting
      sortedBlocks = [...blocks].sort(
        (a, b) => a.settings.sort_order_mobile - b.settings.sort_order_mobile,
      );
    }
  }

  if (isMobile) {
    backgroundImage =
      settings.section.background_image_mobile ||
      settings.section.background_image;
  }

  const {setupObserver, isInView, componentRef} = useInViewComponent()
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    if (componentRef){
      const timeoutId = setTimeout(() => {
        setupObserver(componentRef, hasShown);
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, []);

  return (
    <div ref={componentRef}>
      {isInView && <div
        className={`${settings.section.reveal_animation_class} relative lg:h-full lg:flex lg:items-center`}
        style={{
          paddingTop: `${settings.section.padding_top}px`,
          paddingBottom: `${settings.section.padding_bottom}px`,
        }}
      >
        <div className="relative w-full justify-end items-end">
          <Layout blocks={sortedBlocks} settings={settings} />
        </div>
      </div>}
      {isInView && backgroundImage && (
        <Image
          imageUrl={backgroundImage}
          isLazy={true}
          classes={"absolute top-0 left-0 object-cover h-full w-full -z-10"}
          alt="Testimonial Image"
        />
      )}
    </div>
  );
};
